const gtmEvents = {
  pageMetaData: 'pageMetaData',
  completeSignup: 'complete-signup',
  paymentComplete: 'payment-complete',
  paymentCompleteThankyou: 'payment-complete-thankyou',
  upgradePayment: 'upgrade-payment',
  subscribe: 'subscribe',
  download: 'download',
  navigationClick: 'navigationClick',
  socialInteraction: 'socialInteraction',
  login: 'login',
  logout: 'logout',
};

export default gtmEvents;
